<template>
  <v-app id="app" :class="{'is-mobile': $vuetify.breakpoint.mobile}">
    <consent-dialog @logout="logout" />

    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </v-app>
</template>

<script>
import ConsentDialog from './components/dialogs/consent/ConsentDialog.vue';

import store from '@/store';
import {actionsTypes as authActionsTypes} from '@/store/modules/auth/actions';

export default {
  name: 'App',
  components: {
    ConsentDialog,
  },

  mounted() {
    window.BH.loadTheme();
  },

  methods: {
    async logout() {
      try {
        await store.dispatch(authActionsTypes.logout);
        window.location.reload(true);
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  },
};
</script>
